// extracted by mini-css-extract-plugin
export default {"wrapper":"FolderList_wrapper__MneWv","header":"FolderList_header__kA-62","folderList":"FolderList_folderList__yVGwV","subFolderWrapper":"FolderList_subFolderWrapper__6aTZ1"};